export default "__VITE_ASSET__BHb7FT9b__"